import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import "./styles/ImportTable.css";
import { Box, Tooltip } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "10px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
    cursor:'pointer' 
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const ImportTable = ({ csvData }) => {
  return (
    <React.Fragment>
  <Box
  sx={{
    width: '100%',
    overflowX: 'auto',
    overflowY: 'auto',
    maxHeight: '400px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    backgroundColor: '#fff',
  }}
>
  <TableContainer component={Paper} sx={{ minWidth: 'max-content' }}>
    <Table stickyHeader className="import-table-body" aria-label="customized table">
      <TableBody>
        {csvData?.slice(0, 9).map((row, parentIndex) => (
          <StyledTableRow key={parentIndex}>
            {row?.map((cell, index) => (
              <StyledTableCell
                key={index}
                sx={{
                  minWidth: 150,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
                className={
                  parentIndex === 0
                    ? "import-table-cell-style-with-bg"
                    : "import-table-cell-style"
                }
              >
                <Tooltip title={cell} placement="top" arrow>
                  <span className="cell-content">{cell}</span>
                </Tooltip>
              </StyledTableCell>
            ))}
          </StyledTableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
</Box>
    </React.Fragment>
  );
};
export default ImportTable;
